/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const BearingEnvelopesIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 42 42"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190,-1245)">
      <g id="Bearing-Envelopes" transform="matrix(0.542569,0,0,0.571048,169.834,377.322)">
        <g transform="matrix(0.632127,-2.57388e-16,-1.00628e-16,0.600602,-1525.62,1519.41)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(0.248962,1.96768e-32,-5.41113e-32,0.249304,-333.623,1326.14)">
          <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0459219,7.73232e-18,-0.000166679,0.121463,-25.9393,1476.89)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0459219,7.53955e-18,-0.000171899,0.125267,10.2741,1455.5)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0380516,0.0244311,0.110399,-0.0632105,-71.9002,1534.87)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0380516,0.0244311,0.109605,-0.0627556,-71.537,1577.4)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0459219,7.90888e-18,-0.000170705,0.124397,-15.5922,1480.39)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0459219,7.31192e-18,-0.000166709,0.121485,20.4033,1462.8)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-0.0392468,0.0226592,-0.0351097,-0.0236088,151.147,1565.26)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-0.0392468,0.0226592,-0.0293517,-0.0197369,146.118,1519.06)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-0.0392468,0.0226592,-0.0350166,-0.0235462,185.873,1502.55)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-0.0392468,0.0226592,-0.0349162,-0.0234786,185.63,1545.3)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0380516,0.0244311,0.110784,-0.0634308,-63.9114,1540.53)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0380516,0.0244311,0.110399,-0.0632101,-63.6377,1583.17)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
      </g>
    </g>
  </svg>,
  'BearingEnvelopesIcon',
);
